import React, { useState, Fragment, useEffect, useRef } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
	Paper, Grid,
	FormControlLabel,
	Checkbox, FormLabel, TextField
} from '@material-ui/core';
import { EirAddressFinder } from '../eir-checkout/EirAddressFinder';
import errormesages from './errormessages';

export default function EirCustomerAddress(props) {
	const { register, getValues, errors, control } = useFormContext();
	const { validation } = errormesages;
	const classes = useStyle();
	const [sameDeliveryAddress, setSameDeliveryAddress] = useState(false);
	const [showPrequalAddress, setShowPrequalAddress] = useState(false);
	const [prequalAdd, setPrequalAdd] = useState('');
	const custAddressInputRef = useRef();
	const custEircodeInputRef = useRef();
	const readOnlyCustEircodeInputRef = useRef();

	useEffect(() => {
		if (getValues('billingAddressEirCode') == getValues('deliveryAddressEirCode')) {
			if (getValues('deliveryAddressaddressLine1') == getValues('billingAddressaddressLine1')) {
				setSameDeliveryAddress(true);
			}
		}
		onloadData();//loading prequal address
	}, []);
	const onloadData = () => {
		if (localStorage.getItem('eir_be_data')) {
			let order = JSON.parse(localStorage.getItem('eir_be_data')).order;
			if (order.prequal && order.prequal.fullAddress) {
				setShowPrequalAddress(true)
				setPrequalAdd((order.prequal.fullAddress).replace(/, /g, ',\n'));
			}
		}
	}
	return (
		<Fragment>
			<Grid item sm={12} className={classes.contactPadding}>
				<Paper className={classes.contactPaper} variant='elevation' elevation={4}>
					<Grid container>
						<Grid item sm={6}>
							<Grid container>
								<Grid item sm={7}>
									<h2 className={classes.contactTxt}>
										Your Address
									</h2>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<FormLabel className={classes.formLabelColor}>{(JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ? 'This is your installation address, and also your billing address. Any equipment which comes with your order will be delivered to this address.' : 'Please enter your eircode to autofill your address.'} </FormLabel>
							</Grid>
							{/*prequal Address section start*/}
							{showPrequalAddress ?
								<Grid item sm={12} xs={12}>
									<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
										<TextField inputRef={custAddressInputRef} color="secondary"
											id="installAddress"
											name="installAddress"
											variant="outlined"
											size="small"
											fullWidth
											multiline
											value={prequalAdd}
											style={{ whiteSpace: 'pre-wrap' }}
											onFocus={() => {
												custAddressInputRef.current.focus();
											}}
										/>
									</Grid>
									{props.broadBandTypeFTH ?
										props.eirCode === null ?
											<Grid item sm={12} xs={12}>
												<Grid item sm={12} xs={12}>
													<p className={classes.notifyMessage}>As you have selected a Fibre Broadband product, we require you to confirm your eircode. Please enter below.</p>
												</Grid>
												<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
													<Controller
														as={<TextField color="secondary" />}
														inputRef={custEircodeInputRef}
														control={control}
														fullWidth
														id="custEircode"
														name="custEircode"
														label="Eircode"
														variant="outlined"
														size="small"
														error={Boolean(errors.custEircode)}
														required
														onFocus={() => {
															custEircodeInputRef.current.focus();
														}}
														rules={{
															required: { value: true, message: validation.custEircodeRequired },
														}}
													/>
													<Grid className={classes.errorMessageHeight}>
														<ErrorMessage errors={errors} name="custEircode">
															{({ message }) => <p className={classes.errorMessage}>{message}</p>}
														</ErrorMessage>
													</Grid>
												</Grid>
											</Grid>
											:
											<Grid item sm={6} xs={12} className={classes.paddingRightTopItem}>
												<TextField inputRef={readOnlyCustEircodeInputRef} color="secondary"
													id="readOnlyCustEircode"
													name="readOnlyCustEircode"
													variant="outlined"
													size="small"
													label="Eircode"
													fullWidth
													value={props.eirCode}
													style={{ whiteSpace: 'pre-wrap' }}
													onFocus={() => {
														readOnlyCustEircodeInputRef.current.focus();
													}}

												/>
											</Grid>
										: ''}
								</Grid>
								:
								<Grid item xs={12}>
									<EirAddressFinder />
								</Grid>
							}
							{/*prequal Address section start*/}
							{!(JSON.parse(localStorage.getItem('eir_be_data')).order.prequal) ?
							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={sameDeliveryAddress}
											color="primary"
											id="sameDeliveryAddress"
											inputRef={register}
											name="sameDeliveryAddress"
											onChange={() => setSameDeliveryAddress((previousState) => !previousState)}
										/>
									}
									label="Delivery address is the same as billing address."
								/>
							</Grid>
							:
							''
							}
							{!sameDeliveryAddress && (
								<Grid item xs={12}>
									<h2 className={classes.contactTxt}>
										Delivery address
									</h2>
									<EirAddressFinder isDeliveryAddress />
								</Grid>
							)}
						</Grid>
					</Grid>

				</Paper>
			</Grid>
		</Fragment>
	);
}